import { useAppSelector } from 'hooks';

export const useFeatureFlag = (flagKey: string): boolean => {
  const flag = useAppSelector((state) => state.featureFlags.flags[flagKey]);

  if (!flag) return false;

  return flag.is_enabled ?? false;
};
